import React, { useContext, useEffect, useState } from "react";
import { Button, Stack, Grid, Container } from "@mui/material";
import "../../../styles/Layout/Admin_Styles/_AdminConfirmationDetails.scss";
// import { fDate } from "../../../utils/formatTime";

import { useNavigate } from "react-router-dom";
import { paths } from "../../../utils/path";
import { decrypt } from "../../../utils/encryptDecrypt";
import HeaderLogoImage from "../../../assets/pdf-logo.png";

const AdminConfirmationDetails = (_props) => {
  const { appliedPost, paymentDetails, email } = _props
  const navigate = useNavigate()

  // useEffect(() => {
  //   setIsLoading(true)
  //   authHttp.get(apisPath?.front?.user?.getPaymentDetail).then((res) => {
  //     // console.log(res?.data?.data?.amount)
  //     if (Object.keys(res?.data?.data).length) {
  //       if (parseInt(res?.data?.data?.amount)) {
  //         const applied = res?.data?.data?.applied_post?.map((data) => {
  //           return data?.name;
  //         });
  //         const tempEmail = decrypt(res?.data?.data?.email)
  //         if (tempEmail?.includes('@')) {
  //           const first = tempEmail?.split('@')[0]
  //           const second = tempEmail?.split('@')[1]
  //           let masked = ''
  //           for (let i = 3; i < first?.length; i++) {
  //             masked += 'X'
  //           }
  //           setEmail(`${first?.slice(0, 3)}${masked}@${second}`)
  //         }
  //         setAppliedPost(applied ? applied : []);
  //         setPaymentDetails(res?.data?.data)
  //       }
  //       else {
  //       //   navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.user?.confirmApplication}`)
  //       }
  //     }
  //     else {
  //       // navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.user?.dashboard}`)
  //     }
  //     setIsLoading(false)
  //   }).catch((err) => {
  //     setIsLoading(false)
  //   //   navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.user?.dashboard}`)
  //   })
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])

  return (
    <div className="admin-confirmation" id="admin-confirmation">

      <div className="print-logo2">
        <div className="headerImg">
          <img src={HeaderLogoImage} alt="ExamImg" />
        </div>
      </div>

      <fieldset className="admin-confirmation--fieldset">
        <legend className="admin-confirmation--legend">
          Payment Confirmation Details
        </legend>
        <p className="admin-confirmation--textPrimary">
          Your transaction has been
          <span className={`${paymentDetails?.order_status === 'Success' ? 'text-success' : 'text-fail'}`}> {paymentDetails?.order_status === 'Success' ? 'Successful' : 'Failed'}</span>. Kindly print this page for your reference and remember to quote your Transaction Number in all future
          communication regarding the payment.
        </p>

        <Stack
          direction={{
            lg: "row",
            md: "row",
            sm: "row",
            xs: "column-reverse",
          }}
          justifyContent="space-between"
          mt={5}
          spacing={4}
        >
          <div className="print-web">
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Exam Name
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--text">
                  {appliedPost.length > 0 && appliedPost.toString()}
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">Candidate's Name</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.name ? decrypt(paymentDetails?.name) : '-'}
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">Email Id</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {email}
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">Application Number</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.application_no}
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">Order ID</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.order_id}
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Transaction Ref. No.
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">{paymentDetails?.bank_ref_no !== 'null' ? paymentDetails?.bank_ref_no : '-'}</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">Amount</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">₹ {paymentDetails?.amount ? paymentDetails?.amount : 0.00}</p>
              </Grid>
              {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Transaction Status
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">{paymentDetails?.order_status}</p>
              </Grid> */}
              {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Transaction Number
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.order_id}
                </p>
              </Grid> */}
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Tracking ID
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.tracking_id !== 'null' ? paymentDetails?.tracking_id : '-'}
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Order Status
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className={`admin-confirmation--textTertiary ${paymentDetails?.order_status === 'Success' ? 'text-success' : 'text-fail'} `}>{paymentDetails?.order_status}</p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textSecondary">
                  Date of Transaction
                </p>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.trans_date !== 'null' ? paymentDetails?.trans_date : '-'}
                </p>
              </Grid>
            </Grid>
          </div>
          <div className="print-view">
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">
                  Exam Name
                </p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--text">
                  {appliedPost.length > 0 && appliedPost.toString()}
                </p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">Candidate's Name</p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.name ? decrypt(paymentDetails?.name) : '-'}
                </p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">Email Id</p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">
                  {email}
                </p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">Application Number</p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.application_no}
                </p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">Order ID</p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.order_id}
                </p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">
                  Transaction Ref. No.
                </p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">{paymentDetails?.bank_ref_no !== 'null' ? paymentDetails?.bank_ref_no : '-'}</p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">Amount</p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">₹ {paymentDetails?.amount ? paymentDetails?.amount : 0.00}</p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">
                  Tracking ID
                </p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.tracking_id !== 'null' ? paymentDetails?.tracking_id : '-'}
                </p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">
                  Order Status
                </p>
              </div>
              <div className="w-50">
                <p className={`admin-confirmation--textTertiary ${paymentDetails?.order_status === 'Success' ? 'text-success' : 'text-fail'} `}>{paymentDetails?.order_status}</p>
              </div>
            </div>
            <div className="print-details d-flex">
              <div className="w-50">
                <p className="admin-confirmation--textSecondary">
                  Date of Transaction
                </p>
              </div>
              <div className="w-50">
                <p className="admin-confirmation--textTertiary">
                  {paymentDetails?.trans_date !== 'null' ? paymentDetails?.trans_date : '-'}
                </p>
              </div>
            </div>
          </div>
        </Stack>
      </fieldset>
      <div className="admin-confirmation--buttons">
        <div className="admin-confirmation--button1">
          <Button variant="contained" onClick={() => {
            const element = document.getElementById('admin-confirmation');
            if (element) {
              window.print(element);
            }
          }}>Print Reciept</Button>
        </div>
        {/* {paymentDetails?.order_status === 'Success' &&
          <div className="admin-confirmation--button2">
            <Button variant="contained" onClick={() => {
              navigate(`${paths?.front?.commonPoint !== '/' ? `${paths?.front?.commonPoint}/` : paths?.front?.commonPoint}${paths?.front?.user?.finalconfirmation}`)
              window.scrollTo(0, 0)
            }}>Download Application Form</Button>
          </div>
        } */}

      </div>

    </div>
  );
};

export default AdminConfirmationDetails;
